// Belt keys match the values accepted by PUT /api/auth/card.
// `color` is the belt itself, `band` the darker colour of the card's bottom strip
// (dark enough for white text), `labelEn` the English name printed on the card.
export const BELTS = [
  { key: "white", color: "#dcdcdc", band: "#475569", label: "Սպիտակ", labelEn: "White" },
  { key: "yellow", color: "#f2c500", band: "#a16207", label: "Դեղին", labelEn: "Yellow" },
  { key: "orange", color: "#f28c00", band: "#b45309", label: "Նարնջագույն", labelEn: "Orange" },
  { key: "green", color: "#1e8f3a", band: "#14532d", label: "Կանաչ", labelEn: "Green" },
  { key: "blue", color: "#1e4fb5", band: "#1e3a8a", label: "Կապույտ", labelEn: "Blue" },
  { key: "brown", color: "#8b4513", band: "#5c2d0c", label: "Շականակագույն", labelEn: "Brown" },
  { key: "black", color: "#111111", band: "#0f172a", label: "Սև", labelEn: "Black" },
];

export const findBelt = (key) => BELTS.find((b) => b.key === key);
